import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { RootState } from '../store/AppStore';

type AuthState = {
  token: string | null;
  theme: 'light' | 'dark';
  loading: boolean;
};

const initialState: AuthState = {
  token: null,
  theme: 'light',
  loading: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    saveToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    toggleTheme: state => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
    },
    loading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    logout: state => {
      state.token = null;
    },
  },
});

export const { saveToken, logout, toggleTheme, loading } = authSlice.actions;

// Other code such as selectors can use the imported `RootState` type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// export const isLoggedIn = (state) => !!state.auth.token;

export default authSlice.reducer;
